import { __assign } from "tslib";
import { schema } from 'normalizr';
import { userSchema, userListSchema } from './user';
import { DeviationResourceType } from '../../../types/deviation';
var getCompositeId = function (typeId, deviationId) {
    return typeId === DeviationResourceType.ART
        ? deviationId
        : "".concat(typeId, "-").concat(deviationId);
};
var getDeviationEntityId = function (value) {
    return getCompositeId(value.typeId, value.deviationId);
};
var getDeviationEntityIds = function (values) {
    return values.map(getDeviationEntityId);
};
var processStrategy = function (value) {
    return __assign(__assign({}, value), { entityId: getDeviationEntityId(value) });
};
var deviationSchema = new schema.Entity('deviation', {
    author: userSchema,
    groupDestination: userSchema,
}, {
    idAttribute: getDeviationEntityId,
    processStrategy: processStrategy,
});
var deviationListSchema = [deviationSchema];
// #region extended deviation
var collectionListSchema = new schema.Array({
    collection: { owner: userSchema, thumb: deviationSchema },
    deviations: deviationListSchema,
});
var relatedContentSchema = new schema.Array({
    deviations: deviationListSchema,
    collections: collectionListSchema,
    groups: userListSchema,
});
var deviationExtendedSchema = new schema.Entity('deviationExtended', {
    relatedContent: relatedContentSchema,
    exclusiveGroup: userSchema,
}, {
    idAttribute: function (value, parent, key) {
        return getCompositeId(parent.typeId, parent.deviationId);
    },
    processStrategy: function (value, parent, key) { return (__assign(__assign({}, value), { parentDeviationEntityId: getCompositeId(parent.typeId, parent.deviationId) })); },
});
// add extended to the deviation schema...
deviationSchema.define({ extended: deviationExtendedSchema });
// #endregion
export { deviationSchema, deviationListSchema, deviationExtendedSchema, getDeviationEntityId, getDeviationEntityIds, getCompositeId, };
//# sourceMappingURL=deviation.js.map